import { CallContent } from "../../../Components/CallApp/CallApp";

export const VaticanCallContent: CallContent[] = [
  {
    Contact: "Janice",
    date: "18 Aug 2024",
    time: "6:59 PM",
    type: "missed",
  },
  {
    Contact: "Janice",
    date: "18 Aug 2024",
    time: "6:58 PM",
    type: "missed",
  },
  {
    Contact: "Janice",
    date: "18 Aug 2024",
    time: "6:57 PM",
    type: "missed",
  },
  {
    Contact: "Janice",
    date: "17 Aug 2024",
    time: "2:32 PM",
    type: "missed",
  },
  {
    Contact: "Janice",
    date: "17 Aug 2024",
    time: "2:31 PM",
    type: "missed",
  },
  {
    Contact: "Moses",
    date: "12 Aug 2024",
    time: "4:15 PM",
    type: "outgoing",
  },
  {
    Contact: "+1 (625) 228 6182",
    date: "8 Aug 2024",
    time: "7:57 PM",
    type: "outgoing",
  },
  {
    Contact: "Moses",
    date: "7 Aug 2024",
    time: "12:34 PM",
    type: "outgoing",
  },
  {
    Contact: "Janice",
    date: "4 Aug 2024",
    time: "5:43 PM",
    type: "outgoing",
  },
  {
    Contact: "Moses",
    date: "2 Aug 2024",
    time: "9:49 PM",
    type: "outgoing",
  },
  {
    Contact: "John",
    date: "1 Aug 2024",
    time: "8:46 PM",
    type: "missed",
  },
  {
    Contact: "John",
    date: "1 Aug 2024",
    time: "8:46 PM",
    type: "missed",
  },
  {
    Contact: "Dennis",
    date: "17 Jul 2024",
    time: "5:28 PM",
    type: "outgoing",
  },
  {
    Contact: "+1 (312) 552 1778",
    date: "15 Jul 2024",
    time: "6:39 PM",
    type: "outgoing",
  },
];
